module.exports = __webpack_public_path__ + "static/case-study-image-7a927ec8e4c7e62f8b0fcf1af92d9b17.png";